/* JSON survives Section Rendering API updates; inline executable scripts do not. */
(function () {
  var mountedSlots = new WeakSet();
  function registerAddons() {
    document.querySelectorAll('[data-tee-addon-variants]:not([data-registered])').forEach(function (node) {
      try {
        var variants = JSON.parse(node.textContent);
        window.teeinblueAddonVariants = window.teeinblueAddonVariants || [];
        variants.forEach(function (variant) {
          if (variant && !window.teeinblueAddonVariants.some(function (existing) { return existing.id === variant.id; })) {
            window.teeinblueAddonVariants.push(variant);
          }
        });
        node.dataset.registered = 'true';
      } catch (error) { console.error('[cart-personalization]', error); }
    });
    var changed = false;
    document.querySelectorAll('.tee-edit-customization').forEach(function (slot) {
      if (!mountedSlots.has(slot)) {
        mountedSlots.add(slot);
        changed = true;
      }
    });
    if (changed) {
      document.dispatchEvent(new Event('shopify-event-cart-modified'));
      document.dispatchEvent(new Event('shopify-event-cart-ajax'));
    }
  }
  registerAddons();
  new MutationObserver(registerAddons).observe(document.body, { childList: true, subtree: true });
})();
